import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function CircularIndeterminate() {
    return (
        <Dialog
            maxWidth='lg'
                open={true}
                aria-describedby="alert-dialog-description">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Enviando.....
            </DialogTitle>
            <DialogContent style={{height:'100px', width:"200px", display:'inline-grid'}}>
                <CircularProgress size={70}  style={{marginTop: '10px',justifySelf: 'center'}}/>
            </DialogContent>
        </Dialog>
    );
}